import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LegalComplianceStamp from '../../components/legal/LegalComplianceStamp';

/**
 * ATTENTION — MODÈLE GÉNÉRIQUE À FAIRE RELIRE PAR UN PROFESSIONNEL DU DROIT.
 * Les champs entre crochets [ ] doivent être complétés avec les vraies informations
 * de l'association avant publication.
 */
const MentionsLegales = () => {
  return (
    <div className="min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" className="inline-flex items-center text-muted-foreground hover:text-primary mb-6" data-testid="legal-back-link">
          <ArrowLeft className="mr-2 h-4 w-4" /> Retour à l'accueil
        </Link>
        <h1 className="text-3xl font-bold mb-8">Mentions légales</h1>

        <div className="prose prose-sm max-w-none space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Éditeur du site</h2>
            <p>Le présent site est édité par PADAID (Pont Alternatif D'AIDE), association régie par la loi du 1er juillet 1901.</p>
            <ul className="list-disc pl-6">
              <li>Siège social : Adresse de domiciliation en cours de finalisation — contact possible via padaid.asso@gmail.com</li>
              <li>Numéro RNA : W062020401</li>
              <li>Adresse email de contact : padaid.asso@gmail.com</li>
              <li>Directeur de la publication : Abakar ALI, Président fondateur</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Hébergement</h2>
            <p>Le site est hébergé par Infomaniak Network SA, société anonyme de droit suisse, dont le siège social est situé Rue Eugène Marziano 25, 1227 Les Acacias, Genève, Suisse (Registre du commerce du canton de Genève, IDE : CHE-103.167.648). Informations complètes disponibles sur infomaniak.com.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Propriété intellectuelle</h2>
            <p>L'ensemble des contenus présents sur ce site (textes, images, logo, vidéos) sont, sauf mention contraire, la propriété de PADAID et sont protégés par le droit d'auteur. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable est interdite.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Responsabilité</h2>
            <p>PADAID s'efforce d'assurer l'exactitude des informations diffusées sur ce site, mais ne peut garantir l'absence d'erreur ou d'omission. L'association ne saurait être tenue responsable des dommages directs ou indirects résultant de l'accès ou de l'utilisation du site.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Contact</h2>
            <p>Pour toute question relative à ces mentions légales, vous pouvez nous contacter à l'adresse padaid.asso@gmail.com.</p>
          </section>
          <LegalComplianceStamp />
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
